import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Divider, Modal, Col, Row, Card } from 'antd';
import NewsService from 'services/promemoria/Promemoria';
import moment from 'moment';
import pdfIcon from 'assets/img/formats/pdf.png';
import xlsIcon from 'assets/img/formats/xls.png';
import csvIcon from 'assets/img/formats/csv.png';
import jsonIcon from 'assets/img/formats/json.png';
import Utils from 'utils';
import { CloseOutlined } from '@ant-design/icons';

function News({ isMobile }) {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    return await NewsService.operations();
  };

  useEffect(() => {
    setLoading(true);
    fetchData().then(({ data }) => {
      setNews(
        data.body.sort((a, b) => new Date(b.dataInizioValidita) - new Date(a.dataInizioValidita))
      );
      setLoading(false);
    });
    return () => setNews([]);
  }, []);

  const News = (title, subtitle, date, content, key) => {
    return (
      <li key={key}>
        <a>
          <div
            tabIndex="0"
            onClick={() =>
              Modal.info({
                className: 'modalHome',
                icon: null,
                closable: false,
                content: (
                  <>
                    <Row className="TopModalDiv">
                      <Col span={23} className="TitlesModals">
                        <h1 className="titleModal h4">{title}</h1>
                      </Col>
                      <Col span={1} className="InfoModals">
                        <button
                          aria-label="Chiudi"
                          onClick={() => {
                            Modal.destroyAll();
                          }}>
                          <CloseOutlined className="p-2" aria-label={null} />
                        </button>
                      </Col>
                    </Row>
                    <Row className="TopModalDiv">
                      <Col span={24} className="TitlesModals">
                        <small className="subtitleModal text-justify">{subtitle}</small>
                      </Col>
                    </Row>
                    <div className="contentModal">
                    <div>
                      <span style={{fontWeight:"600"}}>Data Pubblicazione: </span>{moment(date).format('DD/MM/YYYY')}</div>
                      {/* <p>{content}</p> */}
                    </div>
                  </>
                )
              })
            }
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                Modal.info({
                  className: 'modalHome',
                  icon: null,
                  closable: false,
                  content: (
                    <>
                      <Row className="TopModalDiv">
                        <Col span={23} className="TitlesModals">
                          <h1 className="titleModal h4">{title}</h1>
                        </Col>
                        <Col span={1} className="InfoModals">
                          <button
                            aria-label="Chiudi"
                            onClick={() => {
                              Modal.destroyAll();
                            }}>
                            <CloseOutlined className="p-2" aria-label={null} />
                          </button>
                        </Col>
                      </Row>
                      <Row className="TopModalDiv">
                        <Col span={24} className="TitlesModals">
                          <small className="subtitleModal text-justify">{subtitle}</small>
                        </Col>
                      </Row>
                      <div className="contentModal">
                      <div>
                        <span style={{fontWeight:"600"}}>Data Pubblicazione: </span>{moment(date).format('DD/MM/YYYY')}</div>
                        {/* <p>{content}</p> */}
                      </div>
                    </>
                  )
                });
              }
            }}
            className="news-body">
            {/* <div className="d-flex justify-content-between"> */}
            <div className="news-content">
              <div className="title" role="heading" aria-level="3">{title}</div>
            </div>
            <div>
              <div className="subtitle">{subtitle}</div>
            </div>
            <div className="news-date">
              <div className="date">
                <span style={{fontWeight:"600"}}>{t('home.news.date')}: </span><span className="date-detail">{moment(date).format('DD/MM/YYYY')}</span>
              </div>
            </div>
          </div>
        </a>
      </li>
    );
  };

  return (
    <div className="news-container">
      <h2 className="news-title mb-3">{t('home.news.title')}</h2>
      {/* bottoni scarico News obsoleti: rimossi
        <div className="download-news-btns d-flex ">
          ...
        </div>
      */}
      <Divider className="divisore-blu mt-0" />
      <div className="novita-carta mt-md-0 mt-3">
        <ul style={{ paddingLeft: '0' }}>
          {news.map(
            ({
              titolo,
              testo,
              dataInizioValidita,
              sottotitolo
            }, index) =>
              News(
                titolo,
                testo,
                dataInizioValidita,
                sottotitolo,
                "news-" + index
              )
          )}
        </ul>
        {news && news.length > 0 &&
          <Link
            to={'/home/aggiornamenti'}
            className="seeAllStyle d-flex justify-content-end"
            aria-label={`Vedi tutti`}
            tabIndex={0}>
            Vedi tutti
          </Link>
        }
      </div>
    </div>
  );
}

export default News;
